// INDEX
 
 console.log("index.js läuft");
 console.log("confetti verfügbar?", typeof confetti);
 
/* global confetti */
 
   
     function fire(particleRatio, opts, base, count) {
       confetti(Object.assign({}, base, opts, {
         particleCount: Math.floor(count * particleRatio)
       }));
     }
     
     // --- Linke Kanone ---
     function fireLeft() {
     const count = 250;
     const leftDefaults = {
       origin: { x: 0, y: 0.7 },
       angle: 45,
       colors: ["#F28A07", "#0A91C1"],
       scalar: 1.5,
       ticks: 1400,
     };
     
     fire(0.25, { spread: 56, startVelocity: 55 }, leftDefaults, count);
     fire(0.2, { spread: 100 }, leftDefaults, count);
     fire(0.35, { spread: 160, decay: 0.91, scalar: 0.8 }, leftDefaults, count);
     fire(0.1, { spread: 200, startVelocity: 25, decay: 0.92, scalar: 1.2 }, leftDefaults, count);
     fire(0.1, { spread: 200, startVelocity: 45 }, leftDefaults, count);
     }
   
     // --- Rechte Kanone ---
       function fireRight() {
       const count = 250;
       const rightDefaults = {
         origin: { x: 1, y: 0.8 },
         angle: 120,
         colors: ["#F28A07", "#0A91C1"],
         scalar: 1.5,
         ticks: 1400,
       };
     
       fire(0.25, { spread: 46, startVelocity: 55 }, rightDefaults, count);
       fire(0.2, { spread: 105 }, rightDefaults, count);
       fire(0.35, { spread: 165, decay: 0.91, scalar: 0.8 }, rightDefaults, count);
       fire(0.1, { spread: 200, startVelocity: 25, decay: 0.92, scalar: 1.2 }, rightDefaults, count);
       fire(0.1, { spread: 220, startVelocity: 45 }, rightDefaults, count);
       }
       
       function startConfettiBurst() {
         console.log("startConfettiBurst wurde aufgerufen");
         setTimeout(function () {
           fireLeft();
           setTimeout(fireRight, 250);
         }, 1800);
       }
   
 
 window.addEventListener("load", startConfettiBurst);


/* MIMA */
 
document.addEventListener("DOMContentLoaded", function() {
     const currentYearElement = document.getElementById('currentYear');
     if (currentYearElement) {
         currentYearElement.textContent = new Date().getFullYear();
     }
 });

/*
  * hide / show scroll down arrow depending on visibilit of play-demo-button
  */
  
const scrollDownArrowElement = document.getElementById("scroll-down-arrow");
const playDemoButtonElement = document.getElementById("play-demo-button");


function onVisibilityChange(el, callback) {
    let old_visible;
    return function () {
        let visible = isElementInViewport(el);
        if (visible != old_visible) {
            old_visible = visible;
            if (typeof callback == 'function') {
                callback();
            }
        }
    }
}

if (playDemoButtonElement) {
    const handler = onVisibilityChange(playDemoButtonElement, function () {
        if (isElementInViewport(playDemoButtonElement)) {
            scrollDownArrowElement?.classList.add("hidden");
        } else {
            scrollDownArrowElement?.classList.remove("hidden");
        }
    });

    document.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('load', handler);
    document.addEventListener('scroll', handler);
    window.addEventListener('resize', handler);
}


function isElementInViewport(el) {
    // If jQuery is being used, extract the first DOM element
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    if (!el) return false; // Prevent errors if el is null or undefined

    let rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}


/// animate elements only in view

document.addEventListener("DOMContentLoaded", function () {
    const animatedElements = document.querySelectorAll(".animate-on-view");
    console.log("Gefundene Elemente:", animatedElements.length);
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            console.log("Element:", entry.target);
            console.log("Sichtbar:", entry.isIntersecting);
            console.log("Animation:", entry.target.dataset.animation);
            
            if (entry.isIntersecting) {
                const delay = entry.target.dataset.delay || "0s";
                const duration = entry.target.dataset.duration || "1s";
                
                entry.target.style.animationDelay = delay;
                entry.target.style.animationDuration = duration;
                entry.target.style.animationTimingFunction = "ease-in-out";
                entry.target.style.opacity = "";
                
                entry.target.classList.add("animate__animated", entry.target.dataset.animation);
                
                console.log("Klassen nach hinzufügen:", entry.target.classList);
                console.log("Computed styles:", window.getComputedStyle(entry.target).animationName);
                
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.2 });
    
    animatedElements.forEach(element => {
        observer.observe(element);
    });
});


/// close navbar on click anywhere in the document

document.addEventListener("DOMContentLoaded", function () {
    // Initialize Bootstrap Collapse when clicking a button
    document.querySelectorAll('[data-toggle="collapse"]').forEach(btn => {
        btn.addEventListener('click', function () {
            let target = document.querySelector(this.getAttribute('data-target'));
            if (target) {
                let bsCollapse = new bootstrap.Collapse(target, { toggle: true });
            }
        });
    });

    // Close menu when clicking outside
    document.addEventListener("click", function (event) {
        if (!event.target.closest(".collapse, .navbar-toggler")) {
            document.querySelectorAll(".collapse.show").forEach(el => {
                new bootstrap.Collapse(el, { toggle: false }).hide();
            });
        }
    });
    
});

// Scroll nearest

document.addEventListener('DOMContentLoaded', function() {
  // Alle Links die mit # anfangen
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      
      const targetId = this.getAttribute('href');
      
      // Prüfen ob das Ziel existiert
      if (targetId !== '#') {
        const target = document.querySelector(targetId);
        
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    });
  });
});


// EXTRACASES

const btn_s_ccm = document.getElementById("btn-cc-m");
const s_ccm = document.getElementById("crimecity-mobile");
const btn_s_fhm = document.getElementById("btn-fh-m");
const s_fhm = document.getElementById("fullhouse-mobile");
const btn_s_aim = document.getElementById("btn-ai-m");
const s_aim = document.getElementById("allin-mobile");
const btn_s_sdm = document.getElementById("btn-sd-m");
const s_sdm = document.getElementById("showdown-mobile");

const btn_s_cc = document.getElementById("btn-cc");
const s_cc = document.getElementById("crimecity-desktop");
const btn_s_fh = document.getElementById("btn-fh");
const s_fh = document.getElementById("fullhouse-desktop");
const btn_s_ai = document.getElementById("btn-ai");
const s_ai = document.getElementById("allin-desktop");
const btn_s_sd = document.getElementById("btn-sd");
const s_sd = document.getElementById("showdown-desktop");

const btn_s_01 = document.getElementById("btn-solution-01");
const s_01 = document.getElementById("solution-01");
const btn_s_02 = document.getElementById("btn-solution-02");
const s_02 = document.getElementById("solution-02");
const btn_s_03 = document.getElementById("btn-solution-03");
const s_03 = document.getElementById("solution-03");
const btn_s_04 = document.getElementById("btn-solution-04");
const s_04 = document.getElementById("solution-04");

const btn_s_05 = document.getElementById("btn-solution-05");
const s_05 = document.getElementById("solution-05");
const btn_s_06 = document.getElementById("btn-solution-06");
const s_06 = document.getElementById("solution-06");
const btn_s_07 = document.getElementById("btn-solution-07");
const s_07 = document.getElementById("solution-07");
const btn_s_08 = document.getElementById("btn-solution-08");
const s_08 = document.getElementById("solution-08");

const btn_s_09 = document.getElementById("btn-solution-09");
const s_09 = document.getElementById("solution-09");
const btn_s_10 = document.getElementById("btn-solution-10");
const s_10 = document.getElementById("solution-10");
const btn_s_11 = document.getElementById("btn-solution-11");
const s_11 = document.getElementById("solution-11");
const btn_s_12 = document.getElementById("btn-solution-12");
const s_12 = document.getElementById("solution-12");

const btn_s_13 = document.getElementById("btn-solution-13");
const s_13 = document.getElementById("solution-13");
const btn_s_14 = document.getElementById("btn-solution-14");
const s_14 = document.getElementById("solution-14");
const btn_s_15 = document.getElementById("btn-solution-15");
const s_15 = document.getElementById("solution-15");


function toggleSCCM()
{		
     btn_s_ccm.classList.toggle("open");	
}

function toggleSFHM()
{		
     btn_s_fhm.classList.toggle("open");
}

function toggleSAIM()
{			
    btn_s_aim.classList.toggle("open");
}

function toggleSSDM()
{			
    btn_s_sdm.classList.toggle("open");
}


// DESKTOP TOGGLE FUNKTIONEN - Basierend auf Button-Status statt Collapse-Status

function toggleSCC() {
    const isCurrentOpen = btn_s_cc?.classList.contains("open");
    
    // Schließe alle anderen Desktop-Sections
    s_fh?.classList.remove("show");
    s_ai?.classList.remove("show");
    s_sd?.classList.remove("show");
    
    btn_s_fh?.classList.remove("open");
    btn_s_ai?.classList.remove("open");
    btn_s_sd?.classList.remove("open");

    // Toggle aktuelle Section
    if (isCurrentOpen) {
        s_cc?.classList.remove("show");
        btn_s_cc?.classList.remove("open");
    } else {
        s_cc?.classList.add("show");
        btn_s_cc?.classList.add("open");
    }
}

function toggleSFH() {
    const isCurrentOpen = btn_s_fh?.classList.contains("open");
    
    // Schließe alle anderen Desktop-Sections
    s_cc?.classList.remove("show");
    s_ai?.classList.remove("show");
    s_sd?.classList.remove("show");
    
    btn_s_cc?.classList.remove("open");
    btn_s_ai?.classList.remove("open");
    btn_s_sd?.classList.remove("open");

    // Toggle aktuelle Section
    if (isCurrentOpen) {
        s_fh?.classList.remove("show");
        btn_s_fh?.classList.remove("open");
    } else {
        s_fh?.classList.add("show");
        btn_s_fh?.classList.add("open");
    }
}

function toggleSAI() {
    const isCurrentOpen = btn_s_ai?.classList.contains("open");
    
    // Schließe alle anderen Desktop-Sections
    s_cc?.classList.remove("show");
    s_fh?.classList.remove("show");
    s_sd?.classList.remove("show");
    
    btn_s_cc?.classList.remove("open");
    btn_s_fh?.classList.remove("open");
    btn_s_sd?.classList.remove("open");

    // Toggle aktuelle Section
    if (isCurrentOpen) {
        s_ai?.classList.remove("show");
        btn_s_ai?.classList.remove("open");
    } else {
        s_ai?.classList.add("show");
        btn_s_ai?.classList.add("open");
    }
}

function toggleSSD() {
    const isCurrentOpen = btn_s_sd?.classList.contains("open");
    
    // Schließe alle anderen Desktop-Sections
    s_cc?.classList.remove("show");
    s_fh?.classList.remove("show");
    s_ai?.classList.remove("show");
    
    btn_s_cc?.classList.remove("open");
    btn_s_fh?.classList.remove("open");
    btn_s_ai?.classList.remove("open");

    // Toggle aktuelle Section
    if (isCurrentOpen) {
        s_sd?.classList.remove("show");
        btn_s_sd?.classList.remove("open");
    } else {
        s_sd?.classList.add("show");
        btn_s_sd?.classList.add("open");
    }
}

// MOBILE TOGGLE FUNKTIONEN

function toggleSCCM() {
    const isCurrentOpen = btn_s_ccm?.classList.contains("open");
    
    // Schließe alle anderen Mobile-Sections
    s_fhm?.classList.remove("show");
    s_aim?.classList.remove("show");
    s_sdm?.classList.remove("show");

    btn_s_fhm?.classList.remove("open");
    btn_s_aim?.classList.remove("open");
    btn_s_sdm?.classList.remove("open");

    // Toggle aktuelle Section
    if (isCurrentOpen) {
        s_ccm?.classList.remove("show");
        btn_s_ccm?.classList.remove("open");
    } else {
        s_ccm?.classList.add("show");
        btn_s_ccm?.classList.add("open");
    }
}

function toggleSFHM() {
    const isCurrentOpen = btn_s_fhm?.classList.contains("open");
    
    // Schließe alle anderen Mobile-Sections
    s_ccm?.classList.remove("show");
    s_aim?.classList.remove("show");
    s_sdm?.classList.remove("show");

    btn_s_ccm?.classList.remove("open");
    btn_s_aim?.classList.remove("open");
    btn_s_sdm?.classList.remove("open");

    // Toggle aktuelle Section
    if (isCurrentOpen) {
        s_fhm?.classList.remove("show");
        btn_s_fhm?.classList.remove("open");
    } else {
        s_fhm?.classList.add("show");
        btn_s_fhm?.classList.add("open");
    }
}

function toggleSAIM() {
    const isCurrentOpen = btn_s_aim?.classList.contains("open");
    
    // Schließe alle anderen Mobile-Sections
    s_ccm?.classList.remove("show");
    s_fhm?.classList.remove("show");
    s_sdm?.classList.remove("show");

    btn_s_ccm?.classList.remove("open");
    btn_s_fhm?.classList.remove("open");
    btn_s_sdm?.classList.remove("open");

    // Toggle aktuelle Section
    if (isCurrentOpen) {
        s_aim?.classList.remove("show");
        btn_s_aim?.classList.remove("open");
    } else {
        s_aim?.classList.add("show");
        btn_s_aim?.classList.add("open");
    }
}

function toggleSSDM() {
    const isCurrentOpen = btn_s_sdm?.classList.contains("open");
    
    // Schließe alle anderen Mobile-Sections
    s_ccm?.classList.remove("show");
    s_fhm?.classList.remove("show");
    s_aim?.classList.remove("show");

    btn_s_ccm?.classList.remove("open");
    btn_s_fhm?.classList.remove("open");
    btn_s_aim?.classList.remove("open");

    // Toggle aktuelle Section
    if (isCurrentOpen) {
        s_sdm?.classList.remove("show");
        btn_s_sdm?.classList.remove("open");
    } else {
        s_sdm?.classList.add("show");
        btn_s_sdm?.classList.add("open");
    }
}


function toggleS01()
{
  btn_s_01.classList.toggle("open");
}

function toggleS02()
{
  btn_s_02.classList.toggle("open");
}

function toggleS03()
{
  btn_s_03.classList.toggle("open");
}

function toggleS04()
{
  btn_s_04.classList.toggle("open");
}

function toggleS05()
{
  btn_s_05.classList.toggle("open");
}

function toggleS06()
{
  btn_s_06.classList.toggle("open");
}

function toggleS07()
{
  btn_s_07.classList.toggle("open");
}

function toggleS08()
{
  btn_s_08.classList.toggle("open");
}

function toggleS09()
{
  btn_s_09.classList.toggle("open");
}

function toggleS10()
{
  btn_s_10.classList.toggle("open");
}

function toggleS11()
{
  btn_s_11.classList.toggle("open");
}

function toggleS12()
{
  btn_s_12.classList.toggle("open");
}

function toggleS13()
{
  btn_s_13.classList.toggle("open");
}

function toggleS14()
{
  btn_s_14.classList.toggle("open");
}

function toggleS15()
{
  btn_s_15.classList.toggle("open");
}

const addClickEvent = (btn, callback) => {
    if (btn) {
        btn.addEventListener('click', callback);
    }
};

addClickEvent(btn_s_cc, toggleSCC);
addClickEvent(btn_s_fh, toggleSFH);
addClickEvent(btn_s_ai, toggleSAI);
addClickEvent(btn_s_sd, toggleSSD);

addClickEvent(btn_s_ccm, toggleSCCM);
addClickEvent(btn_s_fhm, toggleSFHM);
addClickEvent(btn_s_aim, toggleSAIM);
addClickEvent(btn_s_sdm, toggleSSDM);

addClickEvent(btn_s_01, toggleS01);
addClickEvent(btn_s_02, toggleS02);
addClickEvent(btn_s_03, toggleS03);
addClickEvent(btn_s_04, toggleS04);

addClickEvent(btn_s_05, toggleS05);
addClickEvent(btn_s_06, toggleS06);
addClickEvent(btn_s_07, toggleS07);
addClickEvent(btn_s_08, toggleS08);

addClickEvent(btn_s_09, toggleS09);
addClickEvent(btn_s_10, toggleS10);
addClickEvent(btn_s_11, toggleS11);
addClickEvent(btn_s_12, toggleS12);
addClickEvent(btn_s_13, toggleS13);
addClickEvent(btn_s_14, toggleS14);
addClickEvent(btn_s_15, toggleS15);


// KIDS

// Define country-specific links for multiple anchors (KIDS)

const countryLinks = {
    US: "https://www.hachetteboardgames.com/products/micromacro-kids-crazy-city-park",
    CA: "https://www.randolph.ca/produit/micromacro-kids-en",
    GB: "https://zatu.com/en-de/search?options%5Bprefix%5D=last&q=mciromacro&_gl=1*em6krj*_up*MQ..*_ga*MTU4MjE3NTYzNi4xNzc2NDE2MjMz*_ga_GG2J73Y424*czE3NzY0MTYyMzIkbzEkZzAkdDE3NzY0MTYyMzIkajYwJGwwJGgyMDg1NTk2Nzc3*_ga_LHM3NSJS9C*czE3NzY0MTYyMzIkbzEkZzAkdDE3NzY0MTYyMzIkajYwJGwwJGgw",
    AU: "https://letsplaygames.com.au/micromacro-kids-crazy-city-park-252894",
    NZ: "https://letsplaygames.co.nz/catalogsearch/result/?q=micromacro",
};

// Fallback link
const defaultLink = "https://micromacro-game.com/kids/en/orderlinks.html";

// Function to update links based on user location
async function updateLinks() {
    try {
        console.log("🌍 Fetching location...");

        // Use a backend proxy (BEST) or restrict API key in ipgeolocation.io settings
        const response = await fetch("https://api.ipgeolocation.io/ipgeo?apiKey=c09c85e6e49143a5862a83cea94f8f65");

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log("✅ API Response:", data);

        if (!data.country_code2) {
            throw new Error("❌ No country code found in response!");
        }

        const countryCode = data.country_code2.toUpperCase(); // Ensure it's uppercase
        console.log("🌎 Detected Country Code:", countryCode);

        // Update all links
        document.querySelectorAll('.dynamic-link').forEach(link => {
            link.href = countryLinks[countryCode] || defaultLink;
            console.log(`🔗 Updated ${link}: ${link.href}`);
        });

    } catch (error) {
        console.error("🚨 Error fetching location:", error);

        // Set fallback link if API fails
        document.querySelectorAll('.dynamic-link').forEach(link => {
            link.href = defaultLink;
        });
    }
}

// Run after DOM is fully loaded
document.addEventListener("DOMContentLoaded", updateLinks);

// Bestimmte Klicks triggern Matomo-Events

$('ul.navbar-nav li a.buy_cta_de').not("body#kids a.buy_cta_de").on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Link', 'Navigation DE Spiel Kaufen']);
    }, 1000);
});

$('div.herosection a.btn.buy_cta_de').not("body#kids a.buy_cta_de").on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Button', 'Button Herosection DE Jetzt Bestellen']);
    }, 1000);
});

$('div.getmima a.btn.buy_cta_de').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Button', 'Button Holt Euch DE Jetzt Bestellen']);
    }, 1000);
});

$('div.getmima p.link_cta_de a.buy_cta_de').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Link', 'Link zu Thalia']);
    }, 1000);
});

$('ul.navbar-nav li a.buy_cta_en').not("body#kids a.buy_cta_en").on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Link', 'Navigation EN Buy Game']);
    }, 1000);
});

$('div.herosection a.btn.buy_cta_en').not("body#kids a.buy_cta_en").on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Button', 'Button Herosection EN Buy Now']);
    }, 1000);
});

$('div.getmima a.btn.buy_cta_en').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Button', 'Button Get Micromacro EN Learn More']);
    }, 1000);
});

$('body#kids ul.navbar-nav li a.buy_cta_de').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Link', 'Navigation DE Kids Jetzt Bestellen']);
    }, 1000);
});

$('body#kids a#ordernow.buy_cta_de').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Button', 'Button Herosection DE Kids Jetzt Bestellen']);
    }, 1000);
});

$('body#kids div.ad-spring25-de a.buy_cta_de').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Button', 'Button Frühjahr 2025 DE Kids Jetzt Bestellen']);
    }, 1000);
});

$('body#kids div.ad_puzzle a.buy_cta_de').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Button', 'Button Noch Nicht Genug DE Kids Jetzt Bestellen']);
    }, 1000);
});

$('body#kids a#badge_de').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Badge', 'Badge DE Kids Frühjahr 2025']);
    }, 1000);
});

$('body#kids ul.navbar-nav li a.buy_cta_en').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Link', 'Navigation EN Kids Order Game']);
    }, 1000);
});

$('body#kids a#ordernow.buy_cta_en').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Button', 'Button Herosection EN Kids Order Now']);
    }, 1000);
});

$('body#kids div.ad-spring25-en a.buy_cta_en').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Button', 'Button Spring 2025 EN Kids Order Now']);
    }, 1000);
});

$('body#kids div.ad_puzzle a.buy_cta_en').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Button', 'Button Cant Get Enough EN Kids Order Now']);
    }, 1000);
});

$('body#kids a#badge_en').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Badge', 'Badge EN Kids Spring 2025']);
    }, 1000);
});

$('body#kids_malstifte a#buy_btn_malstifte').on("click", function(event) {
    setTimeout(function () {
        _paq.push(['trackEvent', 'Klick', 'Badge', 'Button DE Kids Malstifte']);
    }, 1000);
});